module.exports = {
  THEME_DARK: 'theme.dark',
  FORTNOX_TOKEN: 'integrations.fortnox.access-token',
  INVOICE_BANKGIRO: 'invoice.bankgiro',
  INVOICE_PLUSGIRO: 'invoice.plusgiro',
}
